import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'

import phoneFrameImg from '../images/PhoneFrame.png'
import arrowPrev from '../images/arrow_prev.svg'
import arrowNext from '../images/arrow_next.svg'

const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  speed: 350,
  slidesToShow: 1,
  slidesToScroll: 1,
}

const PhoneFrameImg = styled.img`
  display: block;
  width: 320px;
  position: relative;
  z-index: 2;
  pointer-events: none;
`

const Wrapper = styled.div``

const Outer = styled.div`
  display: inline-block;
  position: relative;
`

const Canvas = styled.div`
  position: relative;
  z-index: 1;
  position: absolute;
  top: 18px;
  right: 20px;
  bottom: 18px;
  left: 20px;

  .slick-dots {
    margin: 0;
    padding: 0;
    list-style: none;
    display: block;
    position: absolute;
    bottom: 12px;
    left: 0;
    right: 0;
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: 100%;

    li {
      display: block;
      padding: 12px 4px;
      cursor: pointer;
      outline: none;

      &.slick-active button,
      &:focus button {
        background: #4d5d8c;
      }
    }

    button {
      outline: none;
      display: block;
      background: 0;
      margin: 0;
      width: 14px;
      height: 14px;
      border-radius: 7px;
      background: #fff;
      text-indent: -999px;
      overflow: hidden;
      border: 0;
      cursor: pointer;
    }
  }

  .slick-arrow {
    position: absolute;
    width: 30px;
    height: 30px;
    border: 0;
    margin: 0;
    outline: none;
    overflow: hidden;
    text-indent: -999px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 10;

    &.slick-disabled {
      opacity: 0.3;
    }
  }

  .slick-prev {
    left: 0;
    background: url(${arrowPrev}) center center no-repeat;
    transform: translate(-50px, -50%);
  }

  .slick-next {
    right: 0;
    background: url(${arrowNext}) center center no-repeat;
    transform: translate(50px, -50%);
  }
`

const Slide = styled.img`
  width: 280px;
  height: 604px;
  outline: none;
  display: block;
`

const ScreenImg = styled.img`
  display: block;
  width: 280px;
  height: 604px;
`

const Phone = ({ showSlider, slidesImages, walletImage, ...props }) => (
  <Wrapper {...props}>
    <Outer>
      <Canvas>
        {!showSlider && <ScreenImg src={walletImage.src} alt="" />}
        {showSlider && (
          <Slider {...sliderSettings}>
            {slidesImages.map((slide, index) => (
              <Slide key={index} src={slide.src} alt="" />
            ))}
          </Slider>
        )}
      </Canvas>
      <PhoneFrameImg src={phoneFrameImg} alt="" />
    </Outer>
  </Wrapper>
)

export default Phone
